import { Business, CalendarMonth, Email } from '@mui/icons-material';
import SourceIcon from '@mui/icons-material/Source';
import { Box, Typography } from '@mui/material';
import React from 'react';

import InfoRow from './InfoRow';

interface GeneralSectionProps {
  businessIdentifier: string | null;
  email: string | null;
  enrolledPath: string | null;
  activityStartDate: string | null;
}

const GeneralSection: React.FC<GeneralSectionProps> = ({
  businessIdentifier,
  email,
  enrolledPath,
  activityStartDate,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box
        sx={{
          backgroundColor: 'rgba(25, 118, 210, 0.08)',
          borderRadius: '8px',
          px: 1.5,
          py: 0.8,
          border: '1px solid rgba(25, 118, 210, 0.15)',
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 600,
            color: 'primary.main',
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            textAlign: 'center',
          }}
        >
          General
        </Typography>
      </Box>
      <InfoRow
        label="RUT"
        value={businessIdentifier}
        icon={<Business sx={{ fontSize: '0.8rem', color: 'primary.main' }} />}
      />
      <InfoRow
        label="Email"
        value={email}
        icon={<Email sx={{ fontSize: '0.8rem', color: 'primary.main' }} />}
      />
      {enrolledPath && (
        <InfoRow
          label="Origen"
          value={enrolledPath}
          icon={
            <SourceIcon sx={{ fontSize: '0.8rem', color: 'primary.main' }} />
          }
        />
      )}
      <InfoRow
        label="Fecha de Inicio de Actividad"
        value={activityStartDate}
        icon={
          <CalendarMonth sx={{ fontSize: '0.8rem', color: 'primary.main' }} />
        }
      />
    </Box>
  );
};

export default GeneralSection;
